/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getPointTransactionListItems = state =>
  state && state.list && state.list.items ? state.list.items : null;
export const getPointTransactionListPagination = state =>
  state && state.list && state.list.pagination ? state.list.pagination : null;
export const getPointTransactionListLoading = state =>
  state && state.list && state.list.loading ? state.list.loading : false;
export const getPointTransactionListHideLoading = state =>
  state && state.list && state.list.hideLoading
    ? state.list.hideLoading
    : false;

// point
export const getPointID = state => (state && state.id ? state.id : null);
export const getPointTypeName = state =>
  state && state.type && state.type.name ? state.type.name : null;
export const getPointDescription = point =>
  point && point.description ? point.description : "";
export const getPointAmountText = point =>
  point && point.amount && point.amount.text ? point.amount.text : null;
export const getPointCreatedDateTimeRelative = point =>
  point && point.created_datetime && point.created_datetime.relative
    ? point.created_datetime.relative
    : null;



// WEBPACK FOOTER //
// ./src/selectors/point.js